const $ = require('jquery');
require('../gtm-event/video-events');

'use strict';

const PLUGIN_NAME = 'activateVideoPlayer';

const	DEFAULTS = {
  selector: '',
  type: 'href',
  offsetY: -10
};

const ActivateVideoPlayer = function (selector, options) {
  this.$t = $(selector);
  this.options = $.extend(true, {}, DEFAULTS, options);
  this._defaults = DEFAULTS;
  this.initialise_();
};

ActivateVideoPlayer.prototype.initialise_ = function () {
  this.videoId = this.$t.text();
  this.$t.replaceWith(this.renderVideoElement_());
  this.activateVideoJS_();
};

ActivateVideoPlayer.prototype.renderVideoElement_ = function () {
  return `<iframe src="https://www.youtube-nocookie.com/embed/${this.videoId}" width="720" height="405" title="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen ></iframe>`;
};

ActivateVideoPlayer.prototype.activateVideoJS_ = function () {
  // baad approach to videojs (global variable)
};

/**
 * decide, which methods will be "public"
 */
const API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  const args = arguments;

  return this.each(function () {
    const $this = $(this);

    // get plugin instance
    let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

    // if there's not, create one
    if (!plugin) {
      plugin = new ActivateVideoPlayer(this, value);
      $this.data(`plugin_${PLUGIN_NAME}`, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value](...Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.activate-video-player.js